import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import type { AdminChannelDto, ChannelDto } from '@plugins/newsfeed-lib/types';

/**
 * Editor-only channel management. The frontoffice never calls this: it reads
 * the channel list off the instance payload it already loads, which spares it
 * a second round trip before the filter row can paint.
 */
@Injectable({
  providedIn: 'root',
})
export class ChannelsService {
  private readonly http = inject(HttpClient);

  /** Ordered by the editor's own ordering, with the usage count per channel. */
  list(): Observable<AdminChannelDto[]> {
    return this.http.get<AdminChannelDto[]>('/api/channels');
  }

  /**
   * Bulk save of the whole list. The server diffs it, so a channel left out of
   * the array is deleted and the array index becomes its position — there is
   * deliberately no per-row or reorder endpoint.
   */
  save(channels: ChannelDto[]): Observable<ChannelDto[]> {
    return this.http.put<ChannelDto[]>('/api/channels', { channels });
  }
}
